// libs
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { LanguageSwitcher } from 'o2web-react-core';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Actions
import actions from '../../../actions/nav';

// Required Components
import Nav from '../nav/Nav';

class Sitenav extends Component {
  state = { active: false };

  componentDidMount() {
    const { getNav } = this.props;
    const { customStore } = this.context;
    getNav(customStore);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.closeSitenav();
    }
  }

  toggleSitenav(e) {
    e.preventDefault();
    this.setState(prevState => ({
      active: !prevState.active,
    }));
  }

  closeSitenav() {
    this.setState({
      active: false,
    });
  }


  render() {
    const { t } = this.context;
    const {
      location,
      mainNav,
      secondNav,
    } = this.props;

    return (
      <div className={classNames('sitenav', { 'sitenav--active': this.state.active })}>
        <button className="sitenav__toggle" onClick={(e) => this.toggleSitenav(e)} >
          {t('layout.menu')}
        </button>
        <div className="sitenav__wrapper">
          <div className="primary-nav">
            {mainNav &&
              <Nav links={mainNav} className="sitenav" location={location} />
            }
          </div>
          <div className="secondary-nav">
            {secondNav &&
              <Nav links={secondNav} className="sitenav" location={location} />
            }
            <LanguageSwitcher className="language-switcher" />
          </div>
        </div>
      </div>
    );
  }
}

Sitenav.propTypes = {
  location: PropTypes.object.isRequired,
  getNav: PropTypes.func.isRequired,
  mainNav: PropTypes.array.isRequired,
  secondNav: PropTypes.array.isRequired,
};
Sitenav.contextTypes = {
  customStore: PropTypes.object,
  t: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    mainNav: state.nav.mainNav,
    secondNav: state.nav.secondNav,
  };
}

export default withRouter(connect(mapStateToProps, actions)(Sitenav));



// WEBPACK FOOTER //
// ./src/app/components/layouts/header/SiteNav.js